function formatDate(date, payload) {
  const { delimiter, reverse, ltrFormat } = payload;
  if (ltrFormat) {
    const parts = date.split("/");
    const day = parts[0];
    const month = parts[1];
    const year = parts[2];
    return `${month}${delimiter}${day}${delimiter}${year}`;
  }
  const dateObj = new Date(date);
  const month = dateObj.getMonth() + 1;
  const day = dateObj.getDate();
  const year = dateObj.getFullYear();
  if (reverse) return `${year}${delimiter}${month}${delimiter}${day}`;
  return `${day}${delimiter}${month}${delimiter}${year}`;
}

function toDateKey(date) {
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${date.getFullYear()}-${month}-${day}`;
}

// day1..day6 = Sunday..Friday; exceptions can only close one of the line's regular days
function isDeliveryDay(days, exceptions, date) {
  if (days[`day${date.getDay() + 1}`] !== true) return false;
  const exception = exceptions.find((e) => e.date === toDateKey(date));
  return exception ? exception.isOpen : true;
}

// Next delivery date of each weekday (up to 3); a closed date falls back to the same weekday next week
function getNextDays(days, exceptions = []) {
  const today = new Date();
  const todayKeyDay = (today.getDay() + 1) % 7;
  const nextDays = [];
  const seenWeekdays = new Set();

  for (let i = 1; i <= 14 && nextDays.length < 3; i++) {
    const next = new Date(today);
    next.setDate(today.getDate() + i);
    if (seenWeekdays.has(next.getDay())) continue;
    if (!isDeliveryDay(days, exceptions, next)) continue;
    seenWeekdays.add(next.getDay());

    const suffix = todayKeyDay + i <= 7 && i < 7 ? "הקרוב" : "הבא";
    nextDays.push({
      title: `${next.getDate()}/${next.getMonth() + 1}/${next.getFullYear()}`,
      text: getDayText(next, suffix),
    });
  }

  return nextDays;
}

// Helper function to return text
function getDayText(date, suffix) {
  const day = date.toLocaleString("he-IL", { weekday: "long" });
  return `${day} ${suffix}`;
}

export { formatDate, getNextDays, isDeliveryDay, toDateKey };
